(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('facilitiesGroupGrid', facilitiesGroupGridDirective)
    .controller('facilitiesGroupGridController', facilitiesGroupGridController);

  /** @ngInject */
  function facilitiesGroupGridDirective() {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        groupLabel: '@',
        showPagination: '=',
        chartDataName: '='
      },
      templateUrl:
        'app/components/facilitiesGroupGrid/facilitiesGroupGrid.html',
      controller: 'facilitiesGroupGridController',
      controllerAs: 'vm',
      link: function (scope) {
        scope.vm.groupColumnLabel = scope.groupLabel;
        scope.vm.showPagination = scope.showPagination;
        scope.vm.xOptions = scope.options.x ? scope.options.x : {};
        scope.vm.refresh(scope.options.data);
        scope.$watch('options.data', function (newValue) {
          scope.vm.refresh(newValue);
        });
      }
    };
  }

  /** @ngInject */
  function facilitiesGroupGridController($scope, gridUtils, $translate, brand) {
    var vm = this;

    vm.brand = brand;
    vm.count = 0;
    vm.currentPage = 1;
    vm.groupColumnLabel = '';
    vm.xOptions = {};
    vm.refresh = refreshGridData;
    vm.listFirstType = vm.listSecondType = false;

    init();

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      vm.limitPerPage = gridSettings.limitPerPage;
      vm.pagerLabel = gridSettings.translations;

      $scope.$on('$destroy', destroy);
    }

    function destroy() {}

    function refreshGridData(data) {
      if (!data) {
        return;
      }

      if (data.groupsData) {
        vm.listFirstType = true;
        vm.count = data.groupsData.length;
        vm.columns = [vm.groupColumnLabel].concat(
          data.groupNames,
          $translate.instant('LOYALTY_TOTAL')
        );
        vm.totals = [$translate.instant('LOYALTY_TOTAL')].concat(
          data.groupTotal,
          data.total
        );
        vm.rowsData = data.groupsData.map(function (item) {
          var formattedGroupItem = item.groupValue;
          var sumOfValues = item.values.reduce(function (a, b) {
            return a + b;
          }, 0);
          if (vm.xOptions.tick && vm.xOptions.tick.format) {
            formattedGroupItem = vm.xOptions.tick.format(item.groupValue);
          }
          return {
            group: item.groupValue,
            groupFormatted: formattedGroupItem,
            values: item.values.concat(sumOfValues)
          };
        });
      } else {
        vm.listSecondType = true;
        vm.count = data.length;
        vm.columns = [vm.groupColumnLabel].concat($scope.chartDataName);
        vm.rowsData = data.map(function (item) {
          var formattedGroupItem = item.date;
          if (vm.xOptions.tick && vm.xOptions.tick.format) {
            formattedGroupItem = vm.xOptions.tick.format(item.date);
          }
          return {
            group: item.date,
            groupFormatted: formattedGroupItem,
            values: item.count
          };
        });
      }
    }

    vm.setColor = function (lastItem) {
      if (lastItem) {
        return { color: '#000000', 'font-weight': 900 };
      }
    };
  }
})();
